export default __webpack_public_path__ + "static/media/logotipo-primary.b2c89d2f.png";